<template>
  <div class="user-list-wrap">
    <template-search-list :listApi="listApi"
                          :buttonOption="buttonOption"
                          :defaultSortBy="defaultSortBy"
                          :reload="reload"
                          :selected="selected"
                          @select="setSelected"
                          @searchFilter="getSearchFilter"
                          @showDetail="showDetail">
    </template-search-list>

    <template-detail ref="detailModal"
                     :infoApi="infoApi"
                     :apiParam="apiParam"
                     @reload="reloadList"
                     @close="setSelected">
      <ui-button class="delete-account-button"
                 :color="'red'"
                 @click="deleteAccount">
        <i class="xi-trash"></i> 계정 삭제
      </ui-button>
    </template-detail>
  </div>
</template>

<script>

import {
  getUnauthUserListSs, getUnauthUserInfoSs, deleteUnauthUserSs
} from '@/api/user'

import { EventBus } from '@/utils/event-bus'
import { alertError } from '@/utils/tools'

import TemplateSearchList from '@/components/_template/SearchList'
import TemplateDetail from '@/components/_template/Detail'
import UiButton from '@/components/_ui/UiButton'

export default {
  name: 'UserList',
  components: {
    TemplateSearchList,
    TemplateDetail,
    UiButton
  },
  methods: {
    showDetail (data) {
      this.apiParam = { userNum: data.userNum, userId: data.userId }
    },
    reloadList () {
      this.reload++
    },
    getSearchFilter (value) {
      this.searchFilter = value
    },
    setSelected (row) {
      this.selected = row
    },
    deleteAccount () {
      if (!this.apiParam || !this.apiParam.userNum) return
      const confirmed = confirm('정말로 이 계정을 삭제하시겠습니까?\n삭제 후 해당 아이디로 재가입 가능합니다.')
      if (!confirmed) return

      EventBus.$emit('onLoading', true)
      deleteUnauthUserSs({ userNum: this.apiParam.userNum }).then(() => {
        alert('계정이 삭제되었습니다.')
        if (this.$refs.detailModal) {
          this.$refs.detailModal.closeModal()
        }
        this.reload++
      }).catch(error => {
        alertError('계정 삭제에 실패했습니다.', error)
      }).finally(() => {
        EventBus.$emit('onLoading', false)
      })
    },
  },
  data () {
    return {
      reload: 0,
      selected: null,
      
      infoApi: getUnauthUserInfoSs,
      apiParam: null,
      listApi: getUnauthUserListSs,
      buttonOption: [
        {
          action: 'showDetail',
          columnText: '자세히',
          buttonText: '<i class="xi-arrow-right"></i>'
        }
      ],
      defaultSortBy: '-regDate',
      searchFilter: {}
    }
  }
}
</script>

<style lang="scss" scoped>

.user-list-wrap {
  ::v-deep .template-search-list {
    & > .search-area {
      width: 318px;
    }
  }

  ::v-deep .ui-input-wrap {
    padding-right: 20px !important;
  }

  ::v-deep .table-area {
    margin-right: 70px !important;
  }

  ::v-deep .searching {
    & > .table-area {
      margin-right: 350px !important;
    }
  }
}
</style>
